import type { SetupContext } from 'vue';
import type { CardPaymentScreenEvents } from './types';

export function useCardPaymentController(
  emit: SetupContext<CardPaymentScreenEvents>['emit']
) {
  return {
    back: () => emit('back'),
    help: () => emit('help'),
  };
}
